(function () {
    'use strict';

    angular.module("imApp").factory("categoryDatasService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 636,
                    parameters: parms || {}
                });
            },
            listMainCategories: function (parms) {
                return $ihttp.post({
                    method: 626,
                    parameters: parms || {}
                });
            },
            listCategoryDatas: function (parms) {
                return $ihttp.post({
                    method: 346,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 356,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
